var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center w-100"},[_c('h3',{domProps:{"textContent":_vm._s(_vm.message)}}),_c('img',{attrs:{"src":require("@/theme/images/loading.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }